import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetBookingsExpandedQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Container_Insights_Bookings_Expanded_Bool_Exp>;
  order_by?: Types.InputMaybe<
    | Array<Types.Container_Insights_Bookings_Expanded_Order_By>
    | Types.Container_Insights_Bookings_Expanded_Order_By
  >;
}>;

export type GetBookingsExpandedQuery = {
  __typename?: 'query_root';
  container_insights_bookings_expanded: Array<{
    __typename?: 'container_insights_bookings_expanded';
    internal_booking_id?: any | null;
    reefer_id?: string | null;
    start_gps?: any | null;
    end_gps?: any | null;
    start_datetime?: any | null;
    end_datetime?: any | null;
    refrigeration_unit_model?: string | null;
    tradelane?: string | null;
    temperature_setpoint?: any | null;
    start_iso?: string | null;
    end_iso?: string | null;
    start_location?: string | null;
    start_long_location?: string | null;
    end_location?: string | null;
    end_long_location?: string | null;
    co2eq_kg?: any | null;
  }>;
};

export const GetBookingsExpandedDocument = gql`
  query GetBookingsExpanded(
    $where: container_insights_bookings_expanded_bool_exp
    $order_by: [container_insights_bookings_expanded_order_by!]
  ) {
    container_insights_bookings_expanded(where: $where, order_by: $order_by) {
      internal_booking_id
      reefer_id
      start_gps
      end_gps
      start_datetime
      end_datetime
      refrigeration_unit_model
      tradelane
      temperature_setpoint
      start_iso
      end_iso
      start_location
      start_long_location
      end_location
      end_long_location
      co2eq_kg
    }
  }
`;

export function useGetBookingsExpandedQuery(
  options?: Omit<Urql.UseQueryArgs<GetBookingsExpandedQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    GetBookingsExpandedQuery,
    GetBookingsExpandedQueryVariables
  >({ query: GetBookingsExpandedDocument, ...options });
}
